import React from 'react'

import moment from 'moment'

import {
    Card,
    Tag,
    Button,
    Row,
    Icon,
    Col,
    Popconfirm
} from 'antd'

import { EEZEE_URL } from '../../..'
import { AD_STATUS } from '../table/ad-status'

export const ACTIONS = {
    PAUSE: 'pause',
    TERMINATE: 'terminate',
    APPROVE: 'approve',
    REMOVE: 'remove'
}

class EezeeAdsProfile extends React.Component {
    render(){

        const { ad } = this.props

        const dateFormat = "YYYY-MM-DD"
        
        const campaignSettings = [{
            label: 'Date Created',
            value: moment(ad.dateCreated).format(dateFormat)
        },{
            label: 'Campaign Type',
            value: ad.campaignType
        },{
            label: 'Conversion Window',
            value: ad.conversionWindow
        },{
            label: "Start Date",
            value: moment(ad.startDate).format(dateFormat)
        },{
            label: "End Date",
            value: moment(ad.endDate).format(dateFormat)
        },{
            label: "Medium",
            value: ad.medium? ad.medium: 'desktop & mobile'
        }]

        const bannerAdSettings = [{
            label: 'Linked URL',
            value: ad.gotoUrl
        },{
            label: 'Page URL',
            value: ad.page.urlFull,
            link: ad.page.urlFull
        },{
            label: 'Page Type',
            value: ad.page.pageType
        },{
            label: 'Dimensions',
            value: ad.dimensions && `${ad.dimensions.width} x ${ad.dimensions.height}`
        },{
            label: 'Banner Image',
            value: 'View',
            link: ad.dimensions && `https://api.eezee.sg/api/images/resize?height=${ad.dimensions.height}&width=${ad.dimensions.width}&url=${ad.imageUrl}`
        }]

        const pricing = [{
            label: 'Daily Budget',
            value: ad.budgetPretty
        },{
            label: 'Bidding Amount (Cost Per Click)',
            value: ad.biddingAmtPretty
        }]

        const stripeDashboardLink = `https://dashboard.stripe.com`

        const billing = [{
            label: "Status",
            value: ad.stripe.status
        },{
            label: "Payment Method Id",
            value: ad.stripe.paymentMethodId || '-'
        },{
            label: "Price Id",
            value: ad.stripe.priceId || '-',
            link: `${stripeDashboardLink}/prices/${ad.stripe.priceId}`
        },{
            label: "Product Id",
            value: ad.stripe.productId || '-',
            link: `${stripeDashboardLink}/products/${ad.stripe.productId}`
        },{
            label: "Subscription Id",
            value: ad.stripe.subscriptionId || '-',
            link: `${stripeDashboardLink}/subscriptions/${ad.stripe.subscriptionId}`
        },{
            label: "Subcription Item Id",
            value: ad.stripe.subscriptionItemId || '-'
        }]

        const productAdSettings = [{
            label: 'Search Term',
            value: ad.searchTerm
        },{
            label: 'Product',
            value: ad.product && ad.product.title,
            link: ad.product && `${EEZEE_URL}/product/${ad.product.uniqTitle}-${ad.product.sku}`
        }]

        const list = [{
            title: "Campaign Settings",
            item: campaignSettings
        },{
            title: "Ad Settings",
            item: ad.campaignType === 'banner'? bannerAdSettings: productAdSettings
        },{
            title: "Pricing",
            item: pricing
        },{
            title: "Billing",
            item: billing
        }]

        return(
            <Card
                title={
                    <Row
                        type="flex"
                        justify="space-between"
                        align="middle"
                    >
                        <Col>
                            {ad.name}
                        </Col>
                        <Col>
                                {ad.status === AD_STATUS.terminated?
                                <Row 
                                gutter={8}
                                type="flex">
                                    <Col>
                                        <Button disabled>
                                            Terminated
                                        </Button>
                                    </Col>
                                    <Col>
                                        {ad.removed?
                                        <Button disabled>
                                            Removed
                                        </Button>
                                        :
                                        <Popconfirm
                                            onConfirm={()=>this.props.onClick(ACTIONS.REMOVE)}
                                            title="Confirm Remove?"
                                        >
                                            <Button
                                                type="danger"
                                            >
                                                Remove
                                            </Button>
                                        </Popconfirm>}
                                    </Col>
                                </Row>
                                :
                                <Row 
                                gutter={8}
                                type="flex">
                                    <Col>
                                        {ad.status === AD_STATUS.paused?
                                        this.renderButton({action: ACTIONS.APPROVE, altText: 'Unpause', type: 'primary', ghost: true })
                                        :
                                        this.renderButton({action: ACTIONS.PAUSE, type: 'danger', ghost: true})}
                                    </Col>
                                    <Col>
                                        {this.renderButton({action: ACTIONS.TERMINATE, type: 'danger'})}
                                    </Col>
                                    <Col>
                                        {ad.approved?
                                            <Button disabled>
                                                <Icon type="check"/> Approved
                                            </Button>
                                            :
                                            this.renderButton({action: ACTIONS.APPROVE})
                                        }
                                    </Col>
                                </Row>
                                }
                        </Col>
                    </Row>
                }
            >
                <Row type="flex">
                {list.map( _list => {
                    return (
                            <Col span={24/list.length}>
                                <div style={{
                                    fontSize: 16,
                                    fontWeight: 500
                                }}>
                                    {_list.title}
                                </div>
                                <div style={{
                                    padding: '16px 0px 24px 0px'
                                }}>
                                    {_list.item.map( _item => {
                                        return (
                                            <div style={{
                                                padding: '8px 0px'
                                            }}>
                                                <div style={{
                                                    fontWeight: 500,
                                                    marginBottom: 12
                                                }}>{_item.label}</div>
                                                {_item.link?
                                                    <a 
                                                    target="_blank"
                                                    href={_item.link}>
                                                        {_item.value}
                                                    </a>
                                                    :
                                                    <div>{_item.value}</div>
                                                }
                                            </div>
                                        )
                                    })}
                                </div>
                            </Col>
                    )
                })}
                </Row>
            </Card>
        )
    }

    renderButton = ( {action, type = 'primary', ghost = false, altText = false} ) => {
        return (
            <Popconfirm
                onConfirm={()=>this.props.onClick(action)}
                title={`Confirm ${altText? altText: action}?`}
            >
                <Button 
                ghost={ghost}
                type={type}>
                    {altText? altText: action.slice(0,1).toUpperCase() + action.slice(1)}
                </Button>
            </Popconfirm>
        )
    }

}

export default EezeeAdsProfile


// WEBPACK FOOTER //
// ./src/components/eezee-ads/profile/index.js